import { ReactElement } from 'react';
import { useTheme } from '@mui/material/styles';
import { IconButton } from '@mui/material';

import { useNavigation } from '..';
import { DockToRightIcon } from '../icons';

export const SidebarIcon = (): ReactElement => {
  const { openNav, isMobile } = useNavigation();
  const theme = useTheme();

  if (!isMobile) return <></>;

  return (
    <IconButton onClick={openNav} size="large" aria-label="Open navigation" edge="start">
      <DockToRightIcon sx={{ color: theme.palette.text.primary }} />
    </IconButton>
  );
};
